import React from 'react'
import Popup from '../../../../popup/Popup'
import { ReactComponent as SurrenderIcon } from "../../../../images/icons/ico-surrender.svg"

export default class SurrenderPopup extends React.Component {
  render() {
    return (
      <Popup
        inlineIconClass="surrender"
        icon={<SurrenderIcon />}
        title="Resign"
        text={[
          'Do you want to give up and end the game?',
          'This means that your opponent will win.',
        ]}
        buttons={[
          { text: 'Back to game' },
          { text: 'Resign', handler: this.props.onSurrender },
        ]}
        onClose={this.props.onClose}
      />
    )
  }
}
